import Marquee from "react-fast-marquee";

import Bloomberg from "../../../../assests/carousel_Img/Bloomberg.svg";
import benzinga from "../../../../assests/carousel_Img/benzinga.svg";
import YahooFinance from "../../../../assests/carousel_Img/YahooFinance.svg";
import Binance from "../../../../assests/svg/binance.svg";
import telechargementImg from "../../../../assests/carousel_Img/telechargement.svg";
import tradingviewSvg from "../../../../assests/carousel_Img/tradingview.svg";
import marketwatchSvg from "../../../../assests/carousel_Img/Cointribune-logo-og-image.png";
import telemerchargementSvg_de from "../../../../assests/carousel_Img/telechargement_de.svg";

import "./index.css";
import { Languagemodel } from "../../../../Slice/translateSlice";
import { useSelector } from "react-redux";

const MEDIA_ITEMS = [
  {
    img: Bloomberg,
    link: "https://www.bloomberg.com/press-releases/2023-04-04/flash-technologies-is-set-to-revolutionize-the-money-transfer-market",
    height: 22,
  },
  {
    img: benzinga,
    link: "https://www.benzinga.com/pressreleases/23/04/g31662539/flash-technologies-is-set-to-revolutionize-the-money-transfer-market",
    height: 18,
  },
  {
    img: YahooFinance,
    link: "https://finance.yahoo.com/news/flash-technologies-set-revolutionize-money-170000615.html",
    height: 28,
  },
  {
    img: Binance,
    link: "https://www.binance.com/en/feed/post/221737",
    height: 24,
  },
  {
    img: telechargementImg,
    link: "https://fr.cointelegraph.com/press-releases/flash-technologies-is-set-to-revolutionize-the-money-transfer-market",
    height: 28,
    deLink:
      "https://de.cointelegraph.com/press-releases/flash-technologies-is-set-to-revolutionize-the-money-transfer-market",
    deImg: true,
  },
  {
    img: tradingviewSvg,
    link: "https://www.tradingview.com/news/reuters.com,2023-04-04:newsml_GNX2nycJb:0/",
    height: 22,
  },
  {
    img: marketwatchSvg,
    link: "https://www.cointribune.com/flash-technologies",
    height: 22,
  },
];

/**
 * Proposition A — Proof strip
 * Thin sticky bottom bar: discreet title + slow monochrome logo marquee.
 */
export default function Media() {
  const lang = useSelector(Languagemodel);
  const langugemode = useSelector((state) => state.translate.mode);

  return (
    <aside className="MediaContent" id="Medias" aria-label={lang["Seen in the media"]}>
      <div className="media-proof-strip">
        <p className="seeIntheMedia">{lang["Seen in the media"]}</p>
        <div className="MediaContentQuery">
          <Marquee gradient={false} speed={28} pauseOnHover>
            {MEDIA_ITEMS.map((item, index) => {
              const href =
                item.deImg && langugemode === "de" ? item.deLink : item.link;
              const src =
                item.deImg && langugemode === "de"
                  ? telemerchargementSvg_de
                  : item.img;
              return (
                <a
                  key={`${item.link}-${index}`}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className="marquee_element"
                >
                  <img
                    src={src}
                    alt=""
                    style={{ height: `${item.height}px` }}
                    loading="lazy"
                  />
                </a>
              );
            })}
          </Marquee>
        </div>
      </div>
    </aside>
  );
}
